import React, { useEffect, useState } from 'react';

// 네이버 · 구글로 가입/로그인 버튼. 서버에 키가 들어 있는 방법만 보인다.
const SocialButtons: React.FC = () => {
  const [on, setOn] = useState<{ naver?: boolean; google?: boolean }>({});

  useEffect(() => {
    let alive = true;
    fetch('/api/auth/social/providers')
      .then(res => (res.ok ? res.json() : {}))
      .then(data => { if (alive) setOn(data || {}); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!on.naver && !on.google) return null;

  const base: React.CSSProperties = {
    display: 'block', width: '100%', padding: '12px 0', borderRadius: 8, fontSize: 15, fontWeight: 600,
    textAlign: 'center', textDecoration: 'none', marginTop: 10, boxSizing: 'border-box'
  };

  return (
    <div style={{ marginTop: 18 }}>
      <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>간편 가입 · 로그인</div>
      {on.naver && (
        <a href="/api/auth/social/naver/start" style={{ ...base, background: '#03C75A', color: '#fff' }}>
          네이버로 시작하기
        </a>
      )}
      {on.google && (
        <a href="/api/auth/social/google/start" style={{ ...base, background: '#fff', color: '#333', border: '1px solid #d0d7de' }}>
          구글로 시작하기
        </a>
      )}
    </div>
  );
};

export default SocialButtons;
